import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useFormService } from '../core/form-service';
import { FORM_STATES } from '../machine/machine-config';

export const StateCallback = ({ state, callback }) => {
  const service = useFormService();
  const isStateMatched = service.state.matches(state);
  useEffect(() => {
    if (isStateMatched) {
      callback();
    }
  }, [callback, isStateMatched]);

  return null;
};
StateCallback.propTypes = {
  state: PropTypes.string.isRequired,
  callback: PropTypes.func.isRequired,
};

export const SaveCallback = ({ onFormSaved }) => (<StateCallback state={FORM_STATES.SAVING_SUCCEEDED} callback={onFormSaved} />);
SaveCallback.propTypes = {
  onFormSaved: PropTypes.func.isRequired,
};

export const CancelCallback = ({ onFormCancelled }) => (<StateCallback state={FORM_STATES.CANCELED} callback={onFormCancelled} />);
CancelCallback.propTypes = {
  onFormCancelled: PropTypes.func.isRequired,
};
